import identify from 'lodash/identity';

export const MessageProducer = (config) => {
  const { target, origin = '*', defaultMessage = {} } = config || {};
  const _target = (target && target.contentWindow) || window.parent;
  if (!_target || typeof _target.postMessage !== 'function') {
    throw new Error('Invalidated message consumer.');
  }

  return (message = {}) => {
    if (typeof message === 'string') {
      _target.postMessage(message, origin);
    } else {
      _target.postMessage(JSON.stringify({ ...defaultMessage, ...message }), origin);
    }
  };
};

const messageFormatters = {
  JSON: (message) => {
    if (typeof message === 'string') {
      try {
        return JSON.parse(message);
      } catch (e) {
        // Ignore this message.
      }
      return {};
    }
    return message;
  },
};

export function isOriginAcceptable(origin, originRegExStr) {
  const originRegEx = new RegExp(originRegExStr, 'i');
  return originRegEx.test(origin);
}

function MessageConsumer(originRegExStr) {
  const { addEventListener, attachEvent } = window;
  let listeners = [];
  this.addListener = (listener) => {
    let isListened = true;
    listeners.push(listener);
    return () => {
      if (isListened) {
        isListened = false;
        listeners.splice(listeners.indexOf(listener), 1);
      }
    };
  };
  this.removeAllListeners = () => {
    const all = [ ...listeners ];
    listeners = [];
    return all;
  };
  const messageHandler = (event) => {
    const { data, origin } = event;
    if (!isOriginAcceptable(origin, originRegExStr)) return;
    listeners.forEach(({ listener, messageFormatter }) => {
      listener(messageFormatter(data), event);
    });
  };
  if (addEventListener) {
    addEventListener('message', messageHandler);
  } else if (attachEvent) {
    attachEvent('onmessage', messageHandler);
  } else {
    throw new Error('Unable to add event listener for current browser.');
  }
}

let messageConsumer;

export const listenEventMessage = (config) => {
  const {
    listener, messageFormatter: defaultMessageFormatter, messageType = 'JSON',
    originRegExStr,
  } = config || {};
  if (!listener) {
    return null;
  }

  messageConsumer = messageConsumer || new MessageConsumer(originRegExStr);

  const messageFormatter = defaultMessageFormatter || messageFormatters[messageType] || identify;
  return messageConsumer.addListener({ listener, messageFormatter });
};

export const removeAllListeners = () => messageConsumer && messageConsumer.removeAllListeners();
